// serviceWorkerRegistration.js
// Registers the service worker for PWA functionality

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
  window.location.hostname === '[::1]' ||
  window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
);

export function register(config) {
  if ('serviceWorker' in navigator) {
    const publicUrl = new URL(process.env.PUBLIC_URL || '', window.location.href);
    if (publicUrl.origin !== window.location.origin) return;

    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL || ''}/service-worker.js`;

      if (isLocalhost) {
        checkValidServiceWorker(swUrl, config);
        navigator.serviceWorker.ready.then(() => {
          console.log('[PWA] Running in offline-first mode (dev). Learn more: https://cra.link/PWA');
        });
      } else {
        registerValidSW(swUrl, config);
      }
    });
  }
}

function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl)
    .then(registration => {
      console.log('[PWA] Service Worker registered:', registration.scope);

      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (!installingWorker) return;
        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              // New content available — notify user
              console.log('[PWA] New content available — will activate after all tabs closed.');
              if (config && config.onUpdate) config.onUpdate(registration);
              // Show update toast
              showUpdateToast();
            } else {
              console.log('[PWA] Content cached for offline use.');
              if (config && config.onSuccess) config.onSuccess(registration);
            }
          }
        };
      };
    })
    .catch(error => {
      console.error('[PWA] Service Worker registration error:', error);
    });
}

function checkValidServiceWorker(swUrl, config) {
  fetch(swUrl, { headers: { 'Service-Worker': 'script' } })
    .then(response => {
      const contentType = response.headers.get('content-type');
      if (response.status === 404 || (contentType && !contentType.includes('javascript'))) {
        navigator.serviceWorker.ready.then(registration => {
          registration.unregister().then(() => window.location.reload());
        });
      } else {
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => console.log('[PWA] No internet — running cached version.'));
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then(registration => registration.unregister())
      .catch(err => console.error(err.message));
  }
}

function showUpdateToast() {
  // Create a simple update notification
  const existing = document.getElementById('wedoo-update-toast');
  if (existing) return;

  const toast = document.createElement('div');
  toast.id = 'wedoo-update-toast';
  toast.innerHTML = `
    <div style="position:fixed;bottom:5rem;left:50%;transform:translateX(-50%);
                background:#1c1c1c;border:1px solid rgba(201,168,76,0.4);
                padding:1rem 1.5rem;display:flex;gap:1rem;align-items:center;
                z-index:99998;box-shadow:0 8px 32px rgba(0,0,0,0.5);
                font-family:'Inter',system-ui,sans-serif;font-size:0.82rem;min-width:280px;">
      <span style="color:#c9a84c;font-size:1.1rem">🔄</span>
      <div style="flex:1;color:#f8f5ef">New version available!</div>
      <button onclick="window.location.reload()" 
              style="background:#c9a84c;color:#0c0c0c;border:none;padding:0.4rem 1rem;
                     font-size:0.7rem;font-weight:600;letter-spacing:0.1em;cursor:pointer;text-transform:uppercase">
        Update
      </button>
      <button onclick="this.closest('#wedoo-update-toast').remove()"
              style="background:none;border:none;color:#8a8278;font-size:1.1rem;cursor:pointer">✕</button>
    </div>
  `;
  document.body.appendChild(toast);
}
